module.exports = __webpack_public_path__ + "static/img/il.874270d6.svg";